module.exports = __webpack_public_path__ + "static/media/5DPO14.ef7b4f2c.jpg";